import { render, staticRenderFns } from "./DNavDropdown.vue?vue&type=template&id=be93acde&scoped=true&"
import script from "./DNavDropdown.vue?vue&type=script&lang=js&"
export * from "./DNavDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DNavDropdown.vue?vue&type=style&index=0&id=be93acde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be93acde",
  null
  
)

export default component.exports